const state = {
  users: [],
  clients: []
}

const actions = {}

const mutations = {
  SOCKET_DISCONNECT (state) {
    state.users = [];
    console.log('Store [ disconnected ]', state.users);
  },
  SOCKET_ONLINE (state, data) {
    state.users = Object.keys(data.users).map(function(key) {
      return data.users[key];
    });
    state.clients = data.clients;
    console.log('Store [ online ]', data);
  },
  SOCKET_OFFLINE (state, data) {
    state.users = Object.keys(data.users).map(function(key) {
      return data.users[key];
    });
    state.clients = data.clients;
    console.log('[ -> offline ]', data);
  },
  SOCKET_SAY (state, data) {
    console.log('[ say ] ', data);
    this._vm.$bus.$emit('say', data);
  },
  SOCKET_ACTION (state, data) {
    console.log('[ action ] ', data);
    if (data.action) {
      this._vm.$bus.$emit(data.action, data || null);
    }
  },
  SOCKET_TEST (state, data) {
    console.log('[ Test ] ', data);
  }
}

const getters = {
  socket_users: (state) => {
    return state.users;
  },
  socket_clients: (state) => {
    return state.clients;
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
